import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App/App";
import AuthWrapper from "./components/App/AuthWrapper";
import ErrorBoundary from "./components/shared/ErrorBoundary";
import { ClerkProvider } from "@clerk/clerk-react";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { clerk } from "./lib/clerk";
import { ThemeProvider } from "./context/ThemeContext";
import SignInUnavailable from "./components/App/SignInUnavailable";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

const root = ReactDOM.createRoot(rootElement);

// Initialize the app after Clerk is loaded. If sign-in can't load at all (its
// service is down, or a blocker or a bad connection stops it), say so plainly
// instead of leaving a blank white page forever.
clerk.load().then(
  () => {
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
            <Provider store={store}>
              <ThemeProvider>
                <AuthWrapper>
                  <App />
                </AuthWrapper>
              </ThemeProvider>
            </Provider>
          </ClerkProvider>
        </ErrorBoundary>
      </React.StrictMode>
    );
  },
  (error) => {
    // eslint-disable-next-line no-console
    console.error("The sign-in service failed to load:", error);
    root.render(<SignInUnavailable />);
  }
);
